<template>
  <div class="container">
    <div class="title-parent">
        <span class="title title-parent">
          <h1 id="HomeTitle">{{ $t('home.home.title') }} {{ userName }}</h1>
        </span>
    </div>

    <div>
      <div class="row">
        <div class="col-xs-12 col-lg-6 col-xl-4 margin-bottom-2"
             v-for="card in serviceCards.filter(card => !card.cardHidden)"
             :key="card.cardTitle"
        >
          <sdx-card
              :label="card.cardTitle"
              :icon-name="card.cardIcon"
              label-aria-level="2"
              class="sdx-card"
          >
            <p :id="card.id +'-text'" class="margin-bottom-2" v-html="card.cardText" />

            <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
            <sdx-button-group layout="fullwidth" class="sdx-button-home-direction text-align-bottom" slot="interaction">
              <sdx-button name="goToService"
                          :data-testid="card.id"
                          :label="this.$t('home.home.buttonText') +' '+ card.cardTitle"
                          @click="goToPage(card.cardRoute)"
              ></sdx-button>
            </sdx-button-group>
          </sdx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userService from '@/services/user.service';
import {getCurrentLanguage} from "@/i18n/i18n";
import envService from "@/services/env.service";

export default {
  data() {
    return {
      userName: ""
    }
  },
  computed: {
    serviceCards() {
      return [
        {
          id: "serviceCardStats",
          cardTitle: this.$t('home.home.stats.title'),
          cardIcon: 'icon-signal',
          cardText: this.$t('home.home.stats.text'),
          cardSecondText: this.$t('home.home.stats.secondText'),
          cardRoute: '/statistics',
          cardHidden: !envService.featureToggleStats() || !userService.hasRightSms()
        },
        {
          id: "serviceCardSmsOutbox",
          cardTitle: this.$t('home.home.smsOutbox.title'),
          cardIcon: 'icon-sent-6',
          cardText: this.$t('home.home.smsOutbox.text'),
          cardSecondText: this.$t('home.home.smsOutbox.secondText'),
          cardRoute: '/outbox',
          cardHidden: !envService.featureToggleSmsOutbox() || !userService.hasRightSms()
        },
        {
          id: "serviceCardSmsInbox",
          cardTitle: this.$t('home.home.smsInbox.title'),
          cardIcon: 'icon-inbox-3',
          cardText: this.$t('home.home.smsInbox.text'),
          cardSecondText: this.$t('home.home.smsInbox.secondText'),
          cardRoute: '/inbox',
          cardHidden: !envService.featureToggleSmsInbox() || !userService.hasRightReceiveSms()
        },
        {
          id: "serviceCardSendSms",
          cardTitle: this.$t('home.home.sendSms.title'),
          cardIcon: 'icon-sms',
          cardText: this.$t('home.home.sendSms.text'),
          cardSecondText: this.$t('home.home.sendSms.secondText'),
          cardRoute: '/sendsms',
          cardHidden: !envService.featureToggleSendSms() || !userService.hasRightSendSms()
        },
        {
          id: "serviceCardCampaign",
          cardTitle: this.$t('home.home.campaign.title'),
          cardIcon: 'icon-smartphones-multiple',
          cardText: this.$t('home.home.campaign.text') + (envService.featureToggleQuickGuide()?this.$t('home.home.campaign.quickguide'):""),
          cardSecondText: this.$t('home.home.campaign.secondText'),
          cardRoute: '/campaigns',
          cardHidden: !envService.featureToggleCampaign() || !userService.hasRightCampaignManager()
        },
        {
          id: "serviceCardApiProducts",
          cardTitle: this.$t('home.home.apiProducts.title'),
          cardIcon: 'icon-products',
          cardText: this.$t('home.home.apiProducts.text'),
          cardSecondText: this.$t('home.home.apiProducts.secondText'),
          cardRoute: '/api-products',
          cardHidden: false
        },
        {
          id: "serviceCardAllowList",
          cardTitle: this.$t('home.home.allowList.title'),
          cardIcon: 'icon-flag-wind',
          cardText: this.$t('home.home.allowList.text'),
          cardSecondText: this.$t('home.home.allowList.secondText'),
          cardRoute: '/prefix/allowlist',
          cardHidden: false
        },
        {
          id: "serviceCardCostLimit",
          cardTitle: this.$t('home.home.costLimit.title'),
          cardIcon: 'icon-coins',
          cardText: this.$t('home.home.costLimit.text'),
          cardSecondText: this.$t('home.home.costLimit.secondText'),
          cardRoute: '/cost/limit',
          cardHidden: false
        }
      ]
    },
  },
  created() {
    this.userName = userService.getLoggedInUser().name
    this.$i18n.locale = getCurrentLanguage()
  }
  ,
  methods: {
    goToPage(Route) {
      this.$router.push(Route);
    }
  },
}
;
</script>

<style scoped>

.title-parent {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
  padding: 4rem 0 4rem 0;
}

.title {
  animation-name: color;
  animation-duration: 20s;
  animation-iteration-count: infinite;
  position: absolute;
  width: 100%;
  left: 0;
  height: 20%;
  color: white;
  background-image: url("~@/assets/violetblue.jpg");
  background-size: cover;
  background-color: rgb(8, 106, 219);
}

</style>
